import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Global } from '@services/core/Global';
import { StorageService } from '@services/core/storage.service';

@Injectable({
  providedIn: 'root'
})
export class BudgetGenerateService {
  private url: string;
  public urlEmployeeType:string;
  public token;
  private storageService = inject(StorageService)
  
  constructor(
    private _http: HttpClient

  ) { 
     this.url = Global.url_app;
     this.token = this.storageService.getJsonValue("token") 
     this.urlEmployeeType = 'assets/data/type-employee.json';
    }


/** */    
protected convertToFilter(objeto): HttpParams {
  let params = new HttpParams(); 
  const hasKeys = Object.keys(objeto)?.length > 0;
  if (hasKeys!=null||hasKeys!=undefined) {
      params = this.createKeys(objeto, params);
  }   
  return params; 
}

protected createKeys(objeto, params) {
  for (const clave in objeto) {
      if (objeto[clave]!=null||objeto[clave]!=undefined) {
          params = params.append(clave, objeto[clave]);
      }
  }
  return params; 
}

  /**crea la url pasandole los parametros ej. {id:1,rut:15} reuturn '1/15 */
  buildUrl(params) {
    let queryParams = '';
    if (params) {
      queryParams = Object.keys(params)
        .map((key) => `${params[key]}`)
        .join('/');
    }
    return queryParams ? `${queryParams}` : '';
  }


 /**salary_plan_version_field_config */

 getSalaryPlanVersion(params): Observable<any> {
  let headers = new HttpHeaders()  
   .set('Content-Type', 'application/json')
   .set('Authorization', this.token);
   let url = this.buildUrl(params);
   let result=this._http.get(this.url+'salary-plan-config/'+url, { headers: headers });
 return result
}

updateSalaryPlanVersion(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.put(this.url+"salary-plan-config/"+params.id, params,{ headers: headers })
}


saveSalaryPlanVersion(body): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token)   
  return  this._http.post(this.url+"salary-plan-config",body, { headers: headers})
}

deleteSalaryPlanVersion(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.delete(this.url+"salary-plan-config/"+params.id,{ headers: headers })
}

/* salary_calculated_items */


getSalaryCalculatedItems(params): Observable<any> {
  let headers = new HttpHeaders()  
   .set('Content-Type', 'application/json')
   .set('Authorization', this.token);
   let url = this.buildUrl(params);
   let result=this._http.get(this.url+'salary-calculated-items/'+url, { headers: headers });
 return result
}

updateSalaryCalculatedItems(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.put(this.url+"salary-calculated-items/"+params.id, params,{ headers: headers })
}

getApsEmployeeValue(params): Observable<any> {
  let headers = new HttpHeaders()  
   .set('Content-Type', 'application/json')
   .set('Authorization', this.token);
   let url = this.buildUrl(params);
   let result=this._http.get(this.url+'aps-employee-value/'+url, { headers: headers });
 return result
}


updateSalaryCalculatedItemsBulk(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.put(this.url+"salary-calculated-items-bulk", params,{ headers: headers })
}


saveSalaryCalculatedItems(body): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token)   
  return  this._http.post(this.url+"salary-calculated-items",body, { headers: headers})
}

deleteSalaryCalculatedItems(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.delete(this.url+"salary-calculated-items/"+params.id,{ headers: headers })
}


/**employee_salary_calculated */


getEmployeeSalaryCalculated(params): Observable<any> {
  let headers = new HttpHeaders()  
   .set('Content-Type', 'application/json')
   .set('Authorization', this.token);
   let url = this.buildUrl(params);
   let result=this._http.get(this.url+'employee-salary-calculated/'+url, { headers: headers });
 return result
}

updateEmployeeSalaryCalculated(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.put(this.url+"employee-salary-calculated/"+params.id, params,{ headers: headers })
}

bulkUpdateEmployeeSalaryCalculated(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.put(this.url+"bulk-update-employee-salary-calculated", params,{ headers: headers })
}


saveEmployeeSalaryCalculated(body): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token)   
  return  this._http.post(this.url+"employee-salary-calculated",body, { headers: headers})
}

deleteEmployeeSalaryCalculated(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.delete(this.url+"employee-salary-calculated/"+params.id,{ headers: headers })
}




/**account_plan_version_field_config */

getAccountPlanConfig(params): Observable<any> {
  let headers = new HttpHeaders()  
   .set('Content-Type', 'application/json')
   .set('Authorization', this.token);
   let url = this.buildUrl(params);
   let result=this._http.get(this.url+'account-plan-config/'+url, { headers: headers });
 return result
}

updateAccountPlanConfig(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.put(this.url+"account-plan-config/"+params.id, params,{ headers: headers })
}


saveAccountPlanConfig(body): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token)   
  return  this._http.post(this.url+"account-plan-config",body, { headers: headers})
}

deleteAccountPlanConfig(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.delete(this.url+"account-plan-config/"+params.id,{ headers: headers })
}


/**departament_plan_config */

getDepartamentBudgetConfig(params): Observable<any> {
  let headers = new HttpHeaders()  
   .set('Content-Type', 'application/json')
   .set('Authorization', this.token);
   let url = this.buildUrl(params);
   let result=this._http.get(this.url+'departament-budget-config/'+url, { headers: headers });
 return result
}

updateDepartamentBudgetConfig(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.put(this.url+"departament-budget-config/"+params.id, params,{ headers: headers })
}


saveDepartamentBudgetConfig(body): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token)   
  return  this._http.post(this.url+"departament-budget-config",body, { headers: headers})
}

deleteDepartamentBudgetConfig(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.delete(this.url+"departament-budget-config/"+params.id,{ headers: headers })
}


/**budget_employee_type */

getBudgetEmployeeType(params): Observable<any> {
  let headers = new HttpHeaders()  
   .set('Content-Type', 'application/json')
   .set('Authorization', this.token);
   let url = this.buildUrl(params);
   let result=this._http.get(this.url+'budget-employee-type/'+url, { headers: headers });
 return result
}

updateBudgetEmployeeType(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.put(this.url+"budget-employee-type/"+params.id, params,{ headers: headers })
}


saveBudgetEmployeeType(body): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token)   
  return  this._http.post(this.url+"budget-employee-type",body, { headers: headers})
}

saveBudgetEmployeeTypeBulk(body): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token)   
  return  this._http.post(this.url+"budget-employee-type/bulk",body, { headers: headers})
}

deleteBudgetEmployeeType(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.delete(this.url+"budget-employee-type/"+params.id,{ headers: headers })
}

/*departament_employee*/

getDepartamentEmployee(params): Observable<any> {
  let headers = new HttpHeaders()  
   .set('Content-Type', 'application/json')
   .set('Authorization', this.token);
   let url = this.buildUrl(params);
   let result=this._http.get(this.url+'departament-employee/'+url, { headers: headers });
 return result
}

updateDepartamentEmployee(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.put(this.url+"departament-employee/"+params.id, params,{ headers: headers })
}

saveDepartamentEmployee(body): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token)   
  return  this._http.post(this.url+"departament-employee",body, { headers: headers})
}

deleteDepartamentEmployee(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.delete(this.url+"departament-employee/"+params.id,{ headers: headers })
}



/*departament_account_employee tabulacion de sueldo*/

getDepartamentAccountEmployee(params): Observable<any> {
  let headers = new HttpHeaders()  
   .set('Content-Type', 'application/json')
   .set('Authorization', this.token);
   let url = this.buildUrl(params);
   let result=this._http.get(this.url+'departament-account-employee/'+url, { headers: headers });
 return result
}

updateDepartamentAccountEmployee(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.put(this.url+"departament-account-employee/"+params.id, params,{ headers: headers })
}

saveDepartamentAccountEmployee(body): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token)   
  return  this._http.post(this.url+"departament-account-employee",body, { headers: headers})
}

deleteDepartamentAccountEmployee(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.delete(this.url+"departament-account-employee/"+params.id,{ headers: headers })
}

//sicroniza los valores con asistente de calculo
syncDepartamentEmployeeCalculated(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  let url = this.buildUrl(params);
  return  this._http.put(this.url+"sync-departament-employee-calculated/"+url, params,{ headers: headers })
}


//category_formula
getCategoryFormula(): Observable<any> { 
  let headers = new HttpHeaders()  
   .set('Content-Type', 'application/json')
   .set('Authorization', this.token);
   let result=this._http.get(this.url+'category-formula/', { headers: headers });
 return result
}



/**departament_account */

getDepartamentAccount(params): Observable<any> {
  let headers = new HttpHeaders()  
   .set('Content-Type', 'application/json')
   .set('Authorization', this.token);
   let url = this.buildUrl(params);
   let result=this._http.get(this.url+'departament-account/'+url, { headers: headers });
 return result
}

updateDepartamentAccount(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.put(this.url+"departament-account/"+params.id, params,{ headers: headers })
}


saveDepartamentAccount(body): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token)   
  return  this._http.post(this.url+"departament-account",body, { headers: headers})
}

deleteDepartamentAccount(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.delete(this.url+"departament-account/"+params.id,{ headers: headers })
}


/**import_type_ref */

getImportTypeRef(): Observable<any> {
  let headers = new HttpHeaders()  
   .set('Content-Type', 'application/json')
   .set('Authorization', this.token);
   let result=this._http.get(this.url+'import-type-ref', { headers: headers });
 return result
}

updateImportTypeRef(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.put(this.url+"import-type-ref/"+params.id, params,{ headers: headers })
}


saveImportTypeRef(body): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token)   
  return  this._http.post(this.url+"import-type-ref",body, { headers: headers})
}

deleteImportTypeRef(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.delete(this.url+"import-type-ref/"+params.id,{ headers: headers })
}

/*budget status ref*/

getBudgetStatusRef(): Observable<any> {
  let headers = new HttpHeaders()  
   .set('Content-Type', 'application/json')
   .set('Authorization', this.token);
   let result=this._http.get(this.url+'budget-status-ref', { headers: headers });
 return result
}

updateBudgetStatusRef(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.put(this.url+"budget-status-ref/"+params.id, params,{ headers: headers })
}

saveBudgetStatusRef(body): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token)   
  return  this._http.post(this.url+"budget-status-ref",body, { headers: headers})
}

deleteBudgetStatusRef(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.delete(this.url+"budget-status-ref/"+params.id,{ headers: headers })
}


/*account_salary*/  


getAccountSalary(params): Observable<any> {
  let headers = new HttpHeaders()  
   .set('Content-Type', 'application/json')
   .set('Authorization', this.token);
   let url = this.buildUrl(params);
   let result=this._http.get(this.url+'account-salary/'+url, { headers: headers });
 return result
}

updateAccountSalary(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.put(this.url+"account-salary/"+params.id, params,{ headers: headers })
}


saveAccountSalary(body): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token)   
  return  this._http.post(this.url+"account-salary",body, { headers: headers})
}

deleteAccountSalary(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.delete(this.url+"account-salary/"+params.id,{ headers: headers })
}



/*budget factors*/

getBudgetFactors(params): Observable<any> {
  let headers = new HttpHeaders()  
   .set('Content-Type', 'application/json')
   .set('Authorization', this.token);
   let url = this.buildUrl(params);
   let result=this._http.get(this.url+'budget-factors/'+url, { headers: headers });
 return result
}

updateBudgetFactors(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.put(this.url+"budget-factors/"+params.id, params,{ headers: headers })
}


saveBudgetFactors(body): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token)   
  return  this._http.post(this.url+"budget-factors",body, { headers: headers})
}

deleteBudgetFactors(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.delete(this.url+"budget-factors/"+params.id,{ headers: headers })
}

/*budget Import _config*/


getBudgetImportLog(params): Observable<any> {
  let headers = new HttpHeaders()  
   .set('Content-Type', 'application/json')
   .set('Authorization', this.token);
   let url = this.buildUrl(params);
   let result=this._http.get(this.url+'budget-import-log/'+url, { headers: headers });
 return result
}

updateBudgetImportLog(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.put(this.url+"budget-import-log/"+params.id, params,{ headers: headers })
}


saveBudgetImportLog(body): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token)   
  return  this._http.post(this.url+"budget-import-log",body, { headers: headers})
}

deleteBudgetImportLog(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.delete(this.url+"budget-import-log/"+params.id,{ headers: headers })
}




/**resumen-departament */

getResumenDepartament(params): Observable<any> {
  let headers = new HttpHeaders()  
   .set('Content-Type', 'application/json')
   .set('Authorization', this.token);
   let url = this.buildUrl(params);
   let result=this._http.get(this.url+'resumen-departament/'+url, { headers: headers });
 return result
}

getResumen(params): Observable<any> {
  let headers = new HttpHeaders()  
   .set('Content-Type', 'application/json')
   .set('Authorization', this.token);
   let url = this.buildUrl(params);
   let result=this._http.get(this.url+'resumen/'+url, { headers: headers });
 return result
}

getExportAasinet(params): Observable<any> {
  let headers = new HttpHeaders()  
   .set('Content-Type', 'application/json')
   .set('Authorization', this.token);
   let url = this.buildUrl(params);
   let result=this._http.get(this.url+'export-aasinet/'+url, { headers: headers });
 return result
}


/**factor-rea */

getFactorRea(params): Observable<any> {
  let headers = new HttpHeaders()  
   .set('Content-Type', 'application/json')
   .set('Authorization', this.token);
   let url = this.buildUrl(params);
   let result=this._http.get(this.url+'factor-rea/'+url, { headers: headers });
 return result
}

updateFactorRea(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.put(this.url+"factor-rea/"+params.id, params,{ headers: headers })
}


saveFactorRea(body): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token)   
  return  this._http.post(this.url+"factor-rea",body, { headers: headers})
}

deleteFactorRea(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.delete(this.url+"factor-rea/"+params.id,{ headers: headers })
}


/**factor-rea */

getItemBudget(): Observable<any> {
  let headers = new HttpHeaders()  
   .set('Content-Type', 'application/json')
   .set('Authorization', this.token);
   let result=this._http.get(this.url+'item-budget', { headers: headers });
 return result
}

updateItemBudget(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.put(this.url+"item-budget/"+params.id, params,{ headers: headers })
}


saveItemBudget(body): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token)   
  return  this._http.post(this.url+"item-budget",body, { headers: headers})
}

deleteItemBudget(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.delete(this.url+"item-budget/"+params.id,{ headers: headers })
}


/**budget */

getBudget(params?: any): Observable<any> {
  let headers = new HttpHeaders()  
   .set('Content-Type', 'application/json')
   .set('Authorization', this.token);
   let url=this.buildUrl(params)
   let result=this._http.get(this.url+'budget-version/'+url, { headers: headers });
 return result
}

updateBudget(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.put(this.url+"budget-version/"+params.id, params,{ headers: headers })
}

setSelectedBudget(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  let url=this.buildUrl(params)
  return  this._http.put(this.url+"set-selected-budget/"+url, params,{ headers: headers })
}


saveBudget(body): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token)   
  return  this._http.post(this.url+"budget-version",body, { headers: headers})
}

deleteBudget(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.delete(this.url+"budget-version/"+params.id,{ headers: headers })
}

cloneBudget(params): Observable<any> {
  let headers = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Authorization', this.token);
  return this._http.post(this.url + "clone-budget", params, { headers: headers });
}



/**budget factors global */
getBudgetFactorsGlobal(): Observable<any> {
  let headers = new HttpHeaders()  
   .set('Content-Type', 'application/json')
   .set('Authorization', this.token);
   let result=this._http.get(this.url+'budget-factors-global', { headers: headers });
 return result
}

updateBudgetFactorsGlobal(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.put(this.url+"budget-factors-global/"+params.id, params,{ headers: headers })
}

saveBudgetFactorsGlobal(body): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token)   
  return  this._http.post(this.url+"budget-factors-global",body, { headers: headers})
}

deleteBudgetFactorsGlobal(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.delete(this.url+"budget-factors-global/"+params.id,{ headers: headers })
}


/*FactorReaGlobal*/
getFactorReaGlobal(): Observable<any> {
  let headers = new HttpHeaders()  
   .set('Content-Type', 'application/json')
   .set('Authorization', this.token);
   let result=this._http.get(this.url+'factor-rea-global', { headers: headers });
 return result
}

updateFactorReaGlobal(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.put(this.url+"factor-rea-global/"+params.id, params,{ headers: headers })
}

saveFactorReaGlobal(body): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token)   
  return  this._http.post(this.url+"factor-rea-global",body, { headers: headers})
}

deleteFactorReaGlobal(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.delete(this.url+"factor-rea-global/"+params.id,{ headers: headers })
}


/** trae las cuentas*/

getAasinetAccount(params): Observable<any> {
  let headers = new HttpHeaders()  
   .set('Content-Type', 'application/json')
   .set('Authorization', this.token);
   let url = this.buildUrl(params);
   let result=this._http.get(this.url+'aasinet-account/'+url, { headers: headers });
 return result
}



getAasinetDepartament(): Observable<any> {
  let headers = new HttpHeaders()
   .set('Content-Type', 'application/json')
   .set('Authorization', this.token);
   let result=this._http.get(this.url+'aasinet-departament', { headers: headers });
 return result
}

  updateSalaries(params): Observable<any> {
    let headers = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Authorization', this.token);
    return this._http.put(this.url+"salaries",params,{ headers: headers })
  }

  updateAccount(params): Observable<any> {
    let headers = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Authorization', this.token);
    return  this._http.put(this.url+"account-salary/"+params.id, params,{ headers: headers })
  }



/**tabulacion de sueldo */
getDepartamentSalary(params): Observable<any> {
  let headers = new HttpHeaders()
   .set('Content-Type', 'application/json')
   .set('Authorization', this.token);
   let url = this.buildUrl(params);
   let result=this._http.get(this.url+'departament-account-employee-summary/'+url, { headers: headers });
 return result
}

  /**tab variable */



 /*sync aasinet */

 syncAssinetSubAccount(): Observable<any> {
  let headers = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Authorization', this.token)   
    return  this._http.put(this.url+"sync-aasinet-sub-account",{} ,{ headers: headers})
}

syncAssinetAccount(): Observable<any> {
  let headers = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Authorization', this.token)   
    return  this._http.put(this.url+"sync-aasinet-account",{}, { headers: headers})
}


syncAssinetDepartament(): Observable<any> {
  let headers = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Authorization', this.token)   
    return  this._http.put(this.url+"sync-aasinet-departament",{}, { headers: headers})
}

syncAssinetFund(): Observable<any> {
  let headers = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Authorization', this.token)   
    return  this._http.put(this.url+"sync-aasinet-fund",{}, { headers: headers})
}

syncAssinetBudget(params): Observable<any> {
  let headers = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Authorization', this.token) 
    let url=this.buildUrl(params)
    return  this._http.put(this.url+"sync-aasinet-budget/"+url,{}, { headers: headers})
}

syncApsEmployeeAccount(params): Observable<any> {
  let headers = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Authorization', this.token)   
    let url=this.buildUrl(params)
    return  this._http.put(this.url+"sync-aps-employee-account/"+url,{}, { headers: headers})
}

syncApsEmployee(): Observable<any> {
  let headers = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Authorization', this.token)   
    return  this._http.put(this.url+"sync-aps-employee",{}, { headers: headers})
}

syncApsDependents(): Observable<any> {
  let headers = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Authorization', this.token)   
    return  this._http.put(this.url+"sync-aps-dependents",{}, { headers: headers})
}

previewImportEmployee(params): Observable<any> {
  let headers = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Authorization', this.token);
  let url = this.buildUrl(params);
  return this._http.get(this.url + "import-employee-preview/" + url, { headers: headers });
}

importEmployee(params, body = {}): Observable<any> {
  let headers = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Authorization', this.token);
  let url = this.buildUrl(params);
  return this._http.put(this.url + "import-employee/" + url, body, { headers: headers });
}

importPreviousBudget(params): Observable<any> {
  let headers = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Authorization', this.token)
    let url=this.buildUrl(params) 
    return  this._http.put(this.url+"import-previous-budget/"+url,{}, { headers: headers})
}

syncAasinetAllAccounts(): Observable<any> {
  let headers = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Authorization', this.token);
  return this._http.post(this.url + "sync-aasinet-all-accounts", {}, { headers: headers });
}

getSyncAasinetAllStatus(): Observable<any> {
  let headers = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Authorization', this.token);
  return this._http.get(this.url + "sync-aasinet-all-status", { headers: headers });
}

syncApsValue(params): Observable<any> {
  let headers = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Authorization', this.token)
    let url=this.buildUrl(params) 
    return  this._http.put(this.url+"sync-aps-value/"+url,{}, { headers: headers})
}


getAasinetSubAccount(params?): Observable<any> {
  let headers = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Authorization', this.token)   
    let url = this.buildUrl(params);
    return  this._http.get(this.url+"aasinet-sub-account/"+url, { headers: headers})
}

 getChildren(params): Observable<any> {
  let headers = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Authorization', this.token)   
    let url = this.buildUrl(params);
    return  this._http.get(this.url+"children/"+url, { headers: headers})
}


saveChildren(body): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token)   
  return  this._http.post(this.url+"children",body,{ headers: headers})
}



updateChildren(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token)   
  return  this._http.put(this.url+"children/"+params.id,params,{ headers: headers})
}

updateDiverse(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token)   
  return  this._http.put(this.url+"employee/"+params.id,params,{ headers: headers})
}


deleteChildren(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token)   
  return  this._http.delete(this.url+"children/"+params.id,{ headers: headers})
}

deleteDiverse(body): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token)   
  return this._http.delete(this.url + "employee", {
    headers: headers,
    body: body
  });
}


/**trae los tipo de empleados */
getEmployeeType(): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token)   
  return  this._http.get(this.url+"employee-type", { headers: headers})
}

/**actualiza el toda la prima.*/
updatePremiumChildren(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token)   
  const url = this.buildUrl(params);
  return  this._http.put(this.url+"update-children-premium/"+url, {},{ headers: headers})
}


/**departament ref */
getDepartamentRef(params): Observable<any> {
  let headers = new HttpHeaders()  
   .set('Content-Type', 'application/json')
   .set('Authorization', this.token);
   let url = this.buildUrl(params);
   let result=this._http.get(this.url+'departament-ref/'+url, { headers: headers });
 return result
}

updateDepartamentRef(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.put(this.url+"departament-ref/"+params.id, params,{ headers: headers })
}

saveDepartamentRef(body): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token)   
  return  this._http.post(this.url+"departament-ref",body, { headers: headers})
}

deleteDepartamentRef(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.delete(this.url+"departament-ref/"+params.id,{ headers: headers })
}


/**aasinet fund */
getAasinetFund(): Observable<any> {
  let headers = new HttpHeaders()  
   .set('Content-Type', 'application/json')
   .set('Authorization', this.token);
   let result=this._http.get(this.url+'aasinet-fund', { headers: headers });
 return result
}

updateAasinetFund(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.put(this.url+"aasinet-fund/"+params.id, params,{ headers: headers })
}

saveAasinetFund(body): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token)   
  return  this._http.post(this.url+"aasinet-fund",body, { headers: headers})
}

deleteAasinetFund(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.delete(this.url+"aasinet-fund/"+params.id,{ headers: headers })
}

/**budget fund */
getBudgetFund(params): Observable<any> {
  let headers = new HttpHeaders()  
   .set('Content-Type', 'application/json')
   .set('Authorization', this.token);
   let url = this.buildUrl(params);
   let result=this._http.get(this.url+'budget-fund/'+url, { headers: headers });
 return result
}

bulkCreateBudgetFund(body): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token)   
  return  this._http.post(this.url+"budget-fund/bulk",body, { headers: headers})
}

updateBudgetFund(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.put(this.url+"budget-fund/"+params.id, params,{ headers: headers })
}

saveBudgetFund(body): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token)   
  return  this._http.post(this.url+"budget-fund",body, { headers: headers})
}

deleteBudgetFund(params): Observable<any> {
  let headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Authorization', this.token);
  return  this._http.delete(this.url+"budget-fund/"+params.id,{ headers: headers })
}







}
